import { render, staticRenderFns } from "./BoardMembershipTable.vue?vue&type=template&id=58495896&scoped=true&"
import script from "./BoardMembershipTable.vue?vue&type=script&setup=true&lang=js&"
export * from "./BoardMembershipTable.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./BoardMembershipTable.vue?vue&type=style&index=0&id=58495896&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58495896",
  null
  
)

export default component.exports